<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="edit-picker-box">
    <el-dialog title="" :visible="true" :before-close="closeBox">
      <el-form ref="form" :model="form" :rules="rules" label-width="200px">
        <el-form-item label="姓名:">
          <el-select
            v-model="form.admin_id"
            filterable
            placeholder="姓名"
            :disabled="id !== 0"
            style="width: 50%"
          >
            <el-option value="" label="全部"></el-option>
            <el-option
              v-for="item in canAddMemberAdmin"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代号:">
          <el-input
            v-model="form.code"
            style="width: 50%"
            placeholder="代号"
            :disabled="id !== 0"
          ></el-input>
        </el-form-item>
        <el-form-item label="买手组:">
          <el-select
            v-model="form.pg_id"
            placeholder="绑定买手组"
            filterable
            style="width: 50%"
          >
            <el-option value="" label="全部"></el-option>
            <el-option
              v-for="item in selectPicker"
              :key="item.k"
              :value="item.k"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色:" prop="role_type">
          <el-select
            v-model="form.role_type"
            placeholder="角色"
            style="width: 50%"
            @change="handleRoleTypeChange"
          >
            <el-option value="4" label="头部买手"></el-option>
            <el-option value="1" label="普通买手"></el-option>
            <el-option value="3" label="兼职买手"></el-option>
            <el-option value="5" label="高级买助"></el-option>
            <el-option value="2" label="中级买助"></el-option>
            <el-option value="6" label="初级买助"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可绑定核心档口次数:">
          <el-input
            v-model="form.month_hexin_bind_num"
            placeholder="输入次数"
            style="width: 50%"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="form.role_type !== '4'" label="开启商城主页：">
          <el-switch
            v-model="form.open_shopping_homepage"
            active-value="1"
            inactive-value="0"
          ></el-switch>
        </el-form-item>
        <!--开启商城主页 需要填信息、新增也有-->
        <div
          v-if="
            (id === 0 && form.open_shopping_homepage === '1') ||
            form.role_type === '4' ||
            form.open_shopping_homepage === '1'
          "
        >
          <el-form-item label="昵称:" prop="nickname">
            <el-input
              v-model="form.nickname"
              placeholder="昵称"
              style="width: 50%"
            ></el-input>
          </el-form-item>
          <el-form-item label="头像:">
            <el-upload
              v-if="!form.avatar"
              :action="action"
              :on-success="uploadSuccess"
              class="upload-demo"
              :show-file-list="false"
              with-credentials
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <div
              v-if="form.avatar"
              style="max-width: 450px; height: auto; position: relative"
            >
              <img
                :src="form.avatar"
                style="object-fit: contain; width: 100%; border: 1px solid #ddd"
              />
              <i
                class="el-icon-circle-close"
                style="
                  font-size: 36px;
                  position: absolute;
                  top: 16px;
                  right: 16px;
                  color: #fff;
                  text-shadow: #000 1px 0 10px;
                  cursor: pointer;
                "
                @click="handleIconClick"
              />
            </div>
          </el-form-item>
          <el-form-item label="标签:" prop="member_tag">
            <el-input
              v-model="form.member_tag"
              placeholder="标签"
              style="width: 50%"
            ></el-input>
          </el-form-item>
          <el-form-item label="买手介绍:" prop="member_desc">
            <el-input
              v-model="form.member_desc"
              placeholder="买手介绍"
              style="width: 50%"
            ></el-input>
          </el-form-item>
          <el-form-item label="商城主页擅长标签:" prop="shopping_homepage_tag">
            <el-tag
              v-for="tag in form.shopping_homepage_tag"
              :key="tag"
              closable
              :disable-transitions="false"
              style="margin-right: 5px"
              @close="handleClose(tag)"
              >{{ tag }}</el-tag
            >
            <el-input
              v-if="inputVisible"
              ref="saveTagInput"
              v-model="inputValue"
              class="input-new-tag"
              placeholder="请输入擅长标签"
              maxlength="8"
              show-word-limit
              size="small"
              style="width: 50%"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >+ 添加</el-button
            >
          </el-form-item>
          <el-form-item label="认证信息:">
            <el-input
              v-model="form.auth_information"
              placeholder="认证信息"
              style="width: 50%"
              maxlength="8"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="负责市场:">
          <el-select
            v-model="form.market_id"
            filterable
            multiple
            placeholder="请选择市场"
          >
            <el-option
              v-for="item in markets"
              :key="item.market_id"
              :value="item.market_id"
              :label="item.market_name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="买手风格:">
          <el-select
            v-model="form.style_id"
            filterable
            multiple
            placeholder="请选择风格"
          >
            <el-option
              v-for="item in styles"
              :key="item.key"
              :value="item.key"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select
            v-model="form.status"
            placeholder="状态"
            style="width: 50%"
          >
            <el-option value="" label="全部"></el-option>
            <el-option value="1" label="启用"></el-option>
            <el-option value="0" label="禁用"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否参与新款初排:">
          <el-select
            v-model="form.new_style_arrange"
            placeholder="是否参与新款初排"
            style="width: 50%"
          >
            <el-option value="1" label="是"></el-option>
            <el-option value="0" label="否"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="">
          <el-button style="width: 25%" @click="closeBox">取消</el-button>
          <el-button type="success" style="width: 25%" @click="submitData">
            确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash-es";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  props: {
    id: {
      // 买手id
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        nickname: "",
        avatar: "",
        member_tag: "",
        shopping_homepage_tag: [],
        member_desc: "",
        admin_id: "",
        code: "",
        pg_id: "",
        role_type: "",
        month_hexin_bind_num: "",
        open_shopping_homepage: "0",
        new_style_arrange: "1",
      },
      rules: {
        rle_type: [
          {
            required: true,
            message: "角色必选",
            trigger: "change",
          },
        ],
        nickname: [
          {
            required: true,
            message: "请输入昵称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "昵称最长可以输入10个字符",
            trigger: "blur",
          },
        ],
        avatar: [{ required: true, message: "请上传头像", trigger: "change" }],
        shopping_homepage_tag: [
          {
            type: "array",
            max: 10,
            message: "最多10个标签",
            trigger: "blur",
          },
        ],
        member_tag: [
          {
            required: true,
            message: "请输入标签",
            trigger: "blur",
          },
        ],
        member_desc: [
          {
            required: true,
            message: "请输入买手介绍",
            trigger: "blur",
          },
        ],
      },
      canAddMemberAdmin: [],
      selectPicker: [],
      fullscreenLoading: false,
      is_show_hexin_input: false,
      is_show_public_input: false,
      markets: [],
      styles: [],
      inputVisible: false,
      inputValue: "",
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  async mounted() {
    await this.getSelectData();
    this.getMarkets();
    this.getStyles();
  },
  methods: {
    handleRoleTypeChange(val) {
      if (val !== "4") {
        this.form.open_shopping_homepage = "0";
      } else {
        this.form.open_shopping_homepage = "1";
      }
    },
    handleIconClick() {
      this.form.avatar = "";
    },
    handleClose(tag) {
      this.form.shopping_homepage_tag.splice(
        this.form.shopping_homepage_tag.indexOf(tag),
        1
      );
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      const { inputValue } = this;
      if (inputValue) {
        this.form.shopping_homepage_tag.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    fetchData() {
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/PickerGroup/pickerMemberDetail", { id: this.id })
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          }
          this.form = result.data.data;
          this.form.shopping_homepage_tag =
            result.data.data.shopping_homepage_tag || [];
          if (
            result.data.data.role_type == 2 ||
            result.data.data.role_type == 6
          ) {
            this.is_show_hexin_input = true;
            this.is_show_public_input = true;
          }
        })
        .catch(() => {});
    },
    getSelectData() {
      this.fullscreenLoading = true;
      const userPormise = new Promise((resolve) => {
        this.$http
          .post("/erp/PickerGroup/canAddMemberAdmin")
          .then((result) => {
            this.fullscreenLoading = false;
            if (result.data.code != 200) {
              return this.$message.error(result.data.msg);
            }

            resolve(result.data.data);
          })
          .catch(() => {});
      });
      userPormise.then((res) => {
        this.canAddMemberAdmin = res;
        this.fullscreenLoading = true;
        this.$http
          .post("/erp/Common/selectPicker")
          .then((result) => {
            this.fullscreenLoading = false;
            if (result.data.code != 200) {
              return this.$message.error(result.data.msg);
            }
            this.selectPicker = result.data.data;
            if (this.id > 0) {
              this.fetchData();
            }
          })
          .catch(() => {});
      });
    },
    getMarkets() {
      this.$http.post("/erp/Common/getFirstMarketList").then((res) => {
        if (res.data.code == 200) {
          this.markets = res.data.data;
        }
      });
    },
    getStyles() {
      this.$http.post("/erp/Common/getStyleList").then((res) => {
        if (res.data.code == 200) {
          this.styles = res.data.data;
        }
      });
    },
    submitData() {
      // 先校验表单
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          this.$http
            .post("/erp/PickerGroup/updateOrAddPickerMember", this.filteredForm)
            .then((result) => {
              this.fullscreenLoading = false;
              if (result.data.code != 200) {
                return this.$message.error(result.data.msg);
              }
              this.$message.success("操作成功");
              this.closeBox();
            })
            .catch(() => {});
        }
      });
    },
    closeBox() {
      this.$emit("onCloseDialog", false);
    },
    uploadSuccess(e) {
      if (e.code != 200) {
        return this.$message.error(e.msg);
      }
      const data = e.data.origin_files;
      if (data.length < 1) {
        return this.$message.error("上传失败");
      }

      this.form.avatar = data[0];
      this.form = cloneDeep(this.form);
    },
  },
};
</script>

<style scoped>
.bottom-buttom {
  display: flex;
  flex-direction: row;
}

.el-dialog {
  width: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/picker/components/EditMember.vue